import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpParams } from '@angular/common/http';
import { IonicModule } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';
import { DataService } from '../data.service';

/**
 *  ADATHIBA JELZÉSE  ·  a kolléga jelzi, a rendszer azonnal javítja.
 *
 *  Öt egyszerű űrlap (csoportváltás, hiányzó óra, rossz óra, nem létező óra, egyéb).
 *  Minden beküldés előtt ELŐNÉZET jön a kiszolgálótól (ugyanaz a kód fut, csak vissza-
 *  görgetve), így a kolléga pontosan azt látja, ami történni fog. Az admin az összes
 *  bejelentést látja, és visszavonhatja a tévest; teendője csak a kézi javításra váróval van
 *  (az automatikusan végrehajtott bejelentést nem kell átnézni).
 *
 *  A választólisták (csoport, tantárgy, tanuló) `datalist`-tel működnek: gépelésre
 *  szűkülnek, és a kiválasztott NÉV alapján oldjuk fel az azonosítót.
 */
@Component({
  selector: 'app-adatjavitas',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './adatjavitas.component.html',
  styleUrls: ['./adatjavitas.component.scss'],
})
export class AdatjavitasComponent implements OnInit {
  intezmeny = '';
  admin = false;
  en: any = {};
  tanev: any = {};
  csoportok: any[] = [];
  osztalyok: any[] = [];
  tantargyak: any[] = [];
  termek: any[] = [];
  munkatarsak: any[] = [];

  tipus: '' | 'csoport_valtas' | 'ora_felvetel' | 'ora_modositas' | 'ora_torles' | 'ora_elmaradt' | 'jogviszony' | 'egyeb' = '';
  readonly tipusok = [
    { kod: 'csoport_valtas', ikon: 'people-outline', cim: 'Tanuló rossz csoportban',
      leiras: 'Ki kell venni, be kell tenni, vagy át kell tenni egy másik csoportba.' },
    { kod: 'ora_felvetel', ikon: 'add-circle-outline', cim: 'Hiányzik egy órám',
      leiras: 'Pl. a 0. órás korrepetálás nem látszik az órarendemben.' },
    { kod: 'ora_modositas', ikon: 'create-outline', cim: 'Rossz egy órám',
      leiras: 'Rossz csoporttal, tantárggyal, teremben vagy időpontban szerepel.' },
    { kod: 'ora_torles', ikon: 'trash-outline', cim: 'Nincs ilyen órám',
      leiras: 'Olyan óra szerepel, amit nem tartok (már nem tartok).' },
    { kod: 'ora_elmaradt', ikon: 'bed-outline', cim: 'Elmaradtak az óráim',
      leiras: 'Beteg/táppénzen voltam, és senki nem helyettesített – ne számítsanak könyveletlennek.' },
    { kod: 'jogviszony', ikon: 'person-remove-outline', cim: 'Tanuló jogviszonya',
      leiras: 'Szünetel (pl. külföldön van), újra jár, vagy kiiratkozott. Osztályfőnöknek.' },
    { kod: 'egyeb', ikon: 'chatbox-ellipses-outline', cim: 'Egyéb adathiba',
      leiras: 'Minden más – leírod, és kézzel javítjuk.' },
  ];
  readonly napok = [{ n: 1, nev: 'hétfő' }, { n: 2, nev: 'kedd' }, { n: 3, nev: 'szerda' }, { n: 4, nev: 'csütörtök' }, { n: 5, nev: 'péntek' }];
  readonly orak = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

  // Űrlap-állapot (a típusok közösen használják, váltáskor alaphelyzet)
  f: any = {};
  tanuloKereso = '';
  tanuloTalalatok: any[] = [];
  tanulo: any = null;
  tanuloCsoportjai: any[] = [];
  sorozatok: any[] = [];
  sorozat: any = null;
  megjegyzes = '';

  elonezet: any = null;
  dolgozik = false;
  hiba = '';
  siker: any = null;

  // Lista
  bejelentesek: any[] = [];
  osszes = false;
  listaToltodik = false;

  private keresoIdozito: any;

  constructor(private http: HttpClient, private data: DataService) {}

  async ngOnInit() {
    const int = await this.data.getFromStorage('sajatIntezmeny');
    this.intezmeny = String(int?.intezmenyId || '').replace(/^\/+|\/+$/g, '');
    try {
      const t: any = await firstValueFrom(this.http.get('/api/adatjavitas/torzs', { params: this.params() }));
      Object.assign(this, {
        admin: !!t.admin, en: t.en || {}, tanev: t.tanev || {}, csoportok: t.csoportok || [], osztalyok: t.osztalyok || [],
        tantargyak: t.tantargyak || [], termek: t.termek || [], munkatarsak: t.munkatarsak || [],
      });
      this.osszes = this.admin;
    } catch (e: any) {
      this.hiba = e?.error?.error || 'Az adatok nem tölthetők be.';
    }
    await this.listaBetolt();
  }

  private params(extra: Record<string, string> = {}): HttpParams {
    let p = new HttpParams().set('intezmeny', this.intezmeny);
    for (const [k, v] of Object.entries(extra)) p = p.set(k, v);
    return p;
  }

  ma(): string {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  }

  /* ── Típusválasztás ── */

  async valaszt(kod: any) {
    this.tipus = kod;
    this.f = { datum: this.ma(), tol: this.ma(), ig: '', hossz: 1, egysegTipus: 'csoport', tanar: this.en.adid, hianyzas_torles: false };
    this.tanuloKereso = ''; this.tanuloTalalatok = []; this.tanulo = null; this.tanuloCsoportjai = [];
    this.sorozat = null; this.sorozatok = []; this.megjegyzes = '';
    this.elonezet = null; this.hiba = ''; this.siker = null;
    if (kod === 'ora_modositas' || kod === 'ora_torles') await this.sorozatokBetolt();
  }

  megse() { this.tipus = ''; this.elonezet = null; this.hiba = ''; }

  tipusCim(kod: string) { return this.tipusok.find((t) => t.kod === kod)?.cim || kod; }

  /* ── Tanuló ── */

  tanuloKeres() {
    clearTimeout(this.keresoIdozito);
    const k = this.tanuloKereso.trim();
    // Ha a datalistből választott, a sor végén ott az azonosító: azt vesszük fel.
    const m = k.match(/–\s*(\d{6,})\s*$/);
    if (m) {
      const t = this.tanuloTalalatok.find((x) => x.oktazon === m[1]);
      if (t) { this.tanuloValaszt(t); return; }
    }
    if (k.length < 2) { this.tanuloTalalatok = []; return; }
    this.keresoIdozito = setTimeout(async () => {
      try {
        const r: any = await firstValueFrom(this.http.get('/api/adatjavitas/tanulok', { params: this.params({ q: k }) }));
        this.tanuloTalalatok = r?.tanulok || [];
      } catch { this.tanuloTalalatok = []; }
    }, 250);
  }

  tanuloCimke(t: any) { return `${t.nev} (${t.osztaly || '–'}) – ${t.oktazon}`; }

  async tanuloValaszt(t: any) {
    this.tanulo = t; this.tanuloKereso = this.tanuloCimke(t); this.elonezet = null;
    this.f.honnan = '';
    try {
      const r: any = await firstValueFrom(this.http.get(`/api/adatjavitas/tanulo/${t.oktazon}`, { params: this.params() }));
      this.tanuloCsoportjai = r?.csoportok || [];
    } catch { this.tanuloCsoportjai = []; }
  }

  tanuloTorol() { this.tanulo = null; this.tanuloKereso = ''; this.tanuloCsoportjai = []; this.elonezet = null; }

  /* ── Név → azonosító (datalist) ── */

  csoportId(nev: string): string | null {
    const n = String(nev || '').trim().toLowerCase();
    if (!n) return null;
    return this.csoportok.find((c) => c.nev.toLowerCase() === n)?.id || null;
  }
  tantargyId(nev: string): string | null {
    const n = String(nev || '').trim().toLowerCase();
    if (!n) return null;
    return this.tantargyak.find((c) => c.nev.toLowerCase() === n)?.id || null;
  }
  csoportCimke(c: any) { return c.osztalyok ? `${c.osztalyok} · ${c.tagok} fő` : `${c.tagok} fő`; }

  /* ── Sorozatok (a tanár heti órái) ── */

  async sorozatokBetolt() {
    this.sorozat = null; this.sorozatok = []; this.elonezet = null;
    try {
      const r: any = await firstValueFrom(this.http.get('/api/adatjavitas/sorozatok',
        { params: this.params({ tanar: this.f.tanar || this.en.adid }) }));
      this.sorozatok = r?.sorozatok || [];
    } catch (e: any) { this.hiba = e?.error?.error || 'Az órák nem tölthetők be.'; }
  }

  sorozatValaszt(s: any) {
    this.sorozat = s; this.elonezet = null;
    this.f.ujCsoport = ''; this.f.ujTantargy = ''; this.f.ujTerem = ''; this.f.ujNap = ''; this.f.ujOra = ''; this.f.ujOsztaly = '';
  }

  napNev(n: number) { return this.napok.find((x) => x.n === Number(n))?.nev || ''; }

  /* ── Beküldés ── */

  private adatok(): any {
    const f = this.f;
    switch (this.tipus) {
      case 'csoport_valtas':
        return { tanulo: this.tanulo?.oktazon, honnan: f.honnan || null, hova: this.csoportId(f.hovaNev),
                 datum: f.datum, hianyzas_torles: !!f.hianyzas_torles && !!f.honnan };
      case 'ora_felvetel':
        return { tanar: f.tanar, nap: f.nap, ora: f.ora, hossz: f.hossz,
                 csoport: f.egysegTipus === 'csoport' ? this.csoportId(f.csoportNev) : null,
                 osztaly: f.egysegTipus === 'osztaly' ? f.osztaly : null,
                 tantargy: this.tantargyId(f.tantargyNev), terem: f.terem || null, tol: f.tol, ig: f.ig || null };
      case 'ora_modositas':
        return { sorozat: this.sorozatKulcs(), tol: f.tol, ig: f.ig || null,
                 uj: { csoport: this.csoportId(f.ujCsoport), osztaly: f.ujOsztaly || null, tantargy: this.tantargyId(f.ujTantargy),
                       terem: f.ujTerem || null, nap: f.ujNap === '' ? null : f.ujNap, ora: f.ujOra === '' ? null : f.ujOra } };
      case 'ora_torles':
        return { sorozat: this.sorozatKulcs(), tol: f.tol, ig: f.ig || null };
      case 'ora_elmaradt':
        return { tanar: f.tanar, tol: f.tol, ig: f.ig || f.tol, ok: f.ok || null };
      case 'jogviszony':
        return { tanulo: this.tanulo?.oktazon, allapot: f.allapot, datum: f.datum, ok: f.ok || null };
      default:
        return { szoveg: f.szoveg };
    }
  }

  private sorozatKulcs() {
    const s = this.sorozat;
    return s ? { tanar: s.tanar, nap: s.nap, ora: s.ora, tantargy: s.tantargy, csoport: s.csoport, osztaly: s.osztaly } : null;
  }

  /** Mezőszintű előellenőrzés, hogy a kiszolgáló üzenete előtt is látszódjon, mi hiányzik. */
  private hianyzik(): string {
    const f = this.f;
    if (this.tipus === 'jogviszony') {
      if (!this.tanulo) return 'Válaszd ki a tanulót.';
      if (!f.allapot) return 'Válaszd ki, mi történt.';
    }
    if (this.tipus === 'csoport_valtas') {
      if (!this.tanulo) return 'Válaszd ki a tanulót.';
      if (f.hovaNev && !this.csoportId(f.hovaNev)) return 'A cél-csoportot a listából válaszd ki.';
      if (!f.honnan && !f.hovaNev) return 'Add meg, honnan kerüljön ki vagy hova kerüljön.';
    }
    if (this.tipus === 'ora_felvetel') {
      if (f.egysegTipus === 'csoport' && !this.csoportId(f.csoportNev)) return 'A csoportot a listából válaszd ki.';
      if (!this.tantargyId(f.tantargyNev)) return 'A tantárgyat a listából válaszd ki.';
    }
    if ((this.tipus === 'ora_modositas' || this.tipus === 'ora_torles') && !this.sorozat) return 'Válaszd ki, melyik óráról van szó.';
    if (this.tipus === 'ora_modositas') {
      if (f.ujCsoport && !this.csoportId(f.ujCsoport)) return 'Az új csoportot a listából válaszd ki.';
      if (f.ujTantargy && !this.tantargyId(f.ujTantargy)) return 'Az új tantárgyat a listából válaszd ki.';
    }
    return '';
  }

  async ellenoriz() { await this.kuld(true); }
  async vegrehajt() { await this.kuld(false); }

  private async kuld(proba: boolean) {
    this.hiba = this.hianyzik();
    if (this.hiba) return;
    this.dolgozik = true;
    try {
      const r: any = await firstValueFrom(this.http.post('/api/adatjavitas/bejelentes', {
        intezmeny: this.intezmeny, tipus: this.tipus, adatok: this.adatok(), megjegyzes: this.megjegyzes || null, proba,
      }));
      if (proba) { this.elonezet = r; } else {
        this.siker = r; this.tipus = ''; this.elonezet = null;
        await this.listaBetolt();
      }
    } catch (e: any) {
      this.hiba = e?.error?.error || 'A kérés nem sikerült.';
      this.elonezet = null;
    } finally { this.dolgozik = false; }
  }

  // Bármely mező változása után az előnézet elavul.
  valtozott() { this.elonezet = null; }

  /* ── Lista, admin ── */

  async listaBetolt() {
    this.listaToltodik = true;
    try {
      const r: any = await firstValueFrom(this.http.get('/api/adatjavitas/bejelentesek',
        { params: this.params(this.osszes ? { osszes: '1' } : {}) }));
      this.bejelentesek = r?.bejelentesek || [];
    } catch { this.bejelentesek = []; } finally { this.listaToltodik = false; }
  }

  async osszesValt() { this.osszes = !this.osszes; await this.listaBetolt(); }

  allapotNev(b: any) {
    return ({ vegrehajtva: 'Javítva', kezire_var: 'Kézi javításra vár', megoldva: 'Megoldva',
              elutasitva: 'Elutasítva', visszavonva: 'Visszavonva' } as any)[b.allapot] || b.allapot;
  }
  allapotSzin(b: any) {
    return ({ vegrehajtva: 'success', kezire_var: 'warning', megoldva: 'success', elutasitva: 'medium', visszavonva: 'medium' } as any)[b.allapot] || 'medium';
  }

  async visszavon(b: any, eroltet = false) {
    const ok = eroltet ? (b._ok || '') : prompt('Visszavonod ezt a javítást? Az eredeti állapot áll vissza.\nIndoklás (a bejelentő látja, nem kötelező):', '');
    if (ok === null) return;
    b._ok = ok;
    try {
      const r: any = await firstValueFrom(this.http.post(`/api/adatjavitas/bejelentes/${b.id}/visszavonas`,
        { intezmeny: this.intezmeny, ok, eroltet }));
      if (!r.kesz) {
        const tovabb = confirm(`A bejelentés óta ezek az adatok változtak:\n\n${(r.utkozes || []).slice(0, 8).join('\n')}\n\nMégis visszavonod (a későbbi változás is elveszhet)?`);
        if (tovabb) await this.visszavon(b, true);
        return;
      }
      await this.listaBetolt();
    } catch (e: any) { alert(e?.error?.error || 'A visszavonás nem sikerült.'); }
  }

  async lezar(b: any, allapot: 'megoldva' | 'elutasitva') {
    const valasz = prompt(allapot === 'megoldva' ? 'Mit javítottál? (a bejelentő látja)' : 'Miért nem javítjuk? (a bejelentő látja)', '');
    if (valasz === null) return;
    try {
      await firstValueFrom(this.http.post(`/api/adatjavitas/bejelentes/${b.id}/lezaras`, { intezmeny: this.intezmeny, allapot, valasz }));
      await this.listaBetolt();
      window.dispatchEvent(new Event('adatjavitas-atnezve'));
    } catch (e: any) { alert(e?.error?.error || 'Nem sikerült.'); }
  }
}
